import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getPlantelsThunk } from "../store/reducers/plantels/plantels.thunks";
import PlantelsHeader from "../components/plantels/PlantelsHeader";
import PlantelsTable from "../components/plantels/PlantelsTable";
import PlantelViewModal from "../components/plantels/PlantelViewModal";
import ConfirmToggleModal from "../components/plantels/ConfirmToggleModal";
import PlantelFormModal from "../components/plantels/PlantelFormModal";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import Pagination from "../components/UI/Pagination";
import {
  clearPlantelsError,
  setPage,
} from "../store/reducers/plantels/plantels.reducer";
import EmptyState from "./UI/EmptyState";

const PlantelsListLayer = () => {
  const dispatch = useDispatch();
  const { list, loading, error, page, pageSize, search, count } = useSelector(
    (state) => state.plantels,
  );

  useEffect(() => {
    dispatch(getPlantelsThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <PlantelsHeader />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearPlantelsError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando planteles..." delay={200} />
        ) : (
          <>
            {/* INFO DE BÚSQUEDA */}
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {/* EMPTY / TABLE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  search
                    ? "mdi:magnify-remove-outline"
                    : "mdi:office-building-outline"
                }
                title={
                  search
                    ? "No se encontraron planteles"
                    : "No hay planteles registrados"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "Comienza agregando un nuevo plantel"
                }
              />
            ) : (
              <>
                <PlantelsTable plantels={list} search={search} />

                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <PlantelViewModal />
      <PlantelFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default PlantelsListLayer;
